
export default {
  name: "LoaderCircle",
  props: {},
};
